<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['CLUSTERIZAÇÃO', $lang.Common.DataTable.Actions]"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.descricao ? obj.descricao.toUpperCase() : ''" />
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ClusterRepository from '@/shared/http/repositories/configurations/cluster.js'
import ClusterSearchScreen from '../search/search.vue'

export default {
  name: 'ClusterList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.push()
      if (this.filters) {
        ClusterRepository.Search(this.filters.descricao, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        ClusterRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      ClusterRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: ClusterSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/clusters/components/list/clusterlist.vue